/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiV0ConstructiondayreportCorrectWorkingTimesTakeUserHoursReportIdUserIdPost$Params {
  takeUserHours: boolean;
  reportId: string;
  userId: string;
}

export function apiV0ConstructiondayreportCorrectWorkingTimesTakeUserHoursReportIdUserIdPost(http: HttpClient, rootUrl: string, params: ApiV0ConstructiondayreportCorrectWorkingTimesTakeUserHoursReportIdUserIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiV0ConstructiondayreportCorrectWorkingTimesTakeUserHoursReportIdUserIdPost.PATH, 'post');
  if (params) {
    rb.path('takeUserHours', params.takeUserHours, {});
    rb.path('reportId', params.reportId, {});
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiV0ConstructiondayreportCorrectWorkingTimesTakeUserHoursReportIdUserIdPost.PATH = '/api/v0/constructiondayreport/correctWorkingTimes/{takeUserHours}/{reportId}/{userId}';
